import React from 'react';

import autoBind from 'react-autobind';
import { If, Then, Else } from 'react-if'
import Switch, { Case } from 'react-switch-case';
import ReactAudioPlayer from 'react-audio-player';
import { Stage, Layer, Rect, Text, Line } from 'react-konva';
import {
  grey,
  green,
  blueGrey,
  blue,
} from '@material-ui/core/colors';

// import other components within the same project here
import Config from "composer/Config.jsx";

import Localization from "composer/Localization.jsx"

import {
  Chip,
  Avatar,
  Icon,
  Button,
  Typography,
  GridList,
  GridListTile,
  GridListTileBar,
} from '@material-ui/core';

import YouTube from "react-youtube";
var getYouTubeID = require("get-youtube-id");

class LocaleOverviewHotspotContent extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      stageWidth: 375,
      stageHeight: 300,
      boxWidth: 100,
      boxHeight: 40,
      boxPadding: 4,
    };
    autoBind(this);
  }

  photoAttachment(payload) {
    let picture0 = payload.picture0;
    let tnPath = "";
    if (picture0 != null) {
      tnPath = Config.UPLOAD_PATH() + picture0.tn_path;
    }
    if (tnPath != "") {
      return (
        <div style={{margin:'6px 0 0 0'}}>
          <img style={{maxWidth:"33%", maxHeight:"33%", borderRadius:'4px'}} src={tnPath}/>
        </div>
      )
    }
  }

  parsePayload(payload) {
    let result = null;
    try {
      result = JSON.parse(payload);
    } catch (err) {
      console.log(err);
    }
    return result;
  }

  simpleDescription() {
    let kind = parseInt(this.props.contentData.kind);
    if (kind != Config.HOTSPOT_CONTENT_SIMPLE_DESCRIPTION) {
      return;
    }
    let payload = this.parsePayload(this.props.contentData.payload);
    if (payload == null) {
      return (<div/>)
    }
    return (
      <div>
        {this.photoAttachment(payload)}
      </div>
    )
  }

  mcText() {
    let kind = parseInt(this.props.contentData.kind);
    if (kind != Config.HOTSPOT_CONTENT_MC_OF_TEXTS && kind != Config.HOTSPOT_CONTENT_MC_OF_TEXTS_MULTI) {
      return;
    }
    let payload = this.parsePayload(this.props.contentData.payload);
    if (payload == null) {
      return (<div/>)
    }
    let ansArr = [payload.ans0, payload.ans1, payload.ans2, payload.ans3];
    let correctArr = [payload.correct0, payload.correct1, payload.correct2, payload.correct3];
    if (kind == Config.HOTSPOT_CONTENT_MC_OF_TEXTS) {
      correctArr = [true, false, false, false];
    }
    return (
      <div>
        {this.photoAttachment(payload)}
        {ansArr.map( (row, i) => {
          let colorBG = grey[600]; // grey = wrong answer // green = right answer
          let resultBG = colorBG;
          let isCorrect = (correctArr[i] != null && correctArr[i]);
          if (isCorrect) {
            resultBG = green[600];
          }

          return (
            <Chip
              key={"mcText " + i}
              style={{margin:"6px 12px 0 0", background:resultBG, color:'White'}}
              avatar={
                <Avatar style={{background:resultBG}}>
                  <Icon style={{color:'White'}}>{isCorrect? "check_circle": "highlight_off"}</Icon>
                </Avatar>
              }
              label={row}
            />
          )
        })}
      </div>
    );
  }

  mcPic() {
    let kind = parseInt(this.props.contentData.kind);
    if (kind != Config.HOTSPOT_CONTENT_MC_OF_PICTURES && kind != Config.HOTSPOT_CONTENT_MC_OF_PICTURES_MULTI) {
      return;
    }
    let payload = this.parsePayload(this.props.contentData.payload);
    if (payload == null) {
      return (<div/>)
    }
    let pictureArr = [payload.picture0, payload.picture1, payload.picture2, payload.picture3];
    let correctArr = [payload.correct0, payload.correct1, payload.correct2, payload.correct3];
    if (kind == Config.HOTSPOT_CONTENT_MC_OF_PICTURES) {
      correctArr = [true, false, false, false];
    }
    return (
      <GridList>
        {pictureArr.map( (row, i) => {
          if (row != null && row.tn_path != null) {
            let isCorrect = (correctArr[i] != null && correctArr[i]);
            return (
              <GridListTile key={"mcPic " + i}>
                <img
                  src={Config.UPLOAD_PATH() + row.tn_path}
                />
                <GridListTileBar
                  title={Localization.strings.CHOICE + " " + (i+1)}
                  actionIcon={
                    <div style={{margin:"0 12px 0 0"}}>
                      <Icon style={{color:'White'}}>{isCorrect? "check_circle": "highlight_off"}</Icon>
                    </div>
                  }
                />
              </GridListTile>
            )
          }
        })}
      </GridList>
    );
  }

  tableAndCell() {
    let kind = parseInt(this.props.contentData.kind);
    if (kind != Config.HOTSPOT_CONTENT_TABLE_AND_CELL) {
      return;
    }
    let payload = this.parsePayload(this.props.contentData.payload);
    if (payload == null) {
      return (<div/>)
    }
    let rows = [];
    if (payload.row_names != null) {
      rows = payload.row_names.split(',');
    }
    let columns = [];
    if (payload.column_names != null) {
      columns = payload.column_names.split(',');
    }
    return (
       <div>
         {Localization.strings.COLUMN + ": "}
         {
           columns.map( (column, i) => {
             return (
               <Chip
                 key={"column " + i}
                 style={{margin:"6px 12px 0 0"}}
                 label={column}
                />
            )})
         }
       <br/>
         {Localization.strings.ROW + ": "}
         {
           rows.map( (row, i) => {
             return (
               <Chip
                 key={"row " + i}
                 style={{margin:"6px 12px 0 0"}}
                 label={row}
                />
            )})
         }
       </div>
    )
  }

  voiceOver() {
    let kind = parseInt(this.props.contentData.kind);
    if (kind != Config.HOTSPOT_CONTENT_VOICE_OVER) {
      return;
    }
    let payload = this.parsePayload(this.props.contentData.payload);
    if (payload == null) {
      return (<div/>)
    }
    let sound0 = payload.sound0;
    if (sound0 != null && sound0.path != "") {
      return (
        <div style={{margin:'6px 0 0 0'}}>
          <ReactAudioPlayer
            controls
            src={Config.UPLOAD_PATH() + sound0.path}
          />
        </div>
      )
    }
    else {
      return (<div/>)
    }
  }

  fillInTheBlank() {
    let kind = parseInt(this.props.contentData.kind);
    if (kind != Config.HOTSPOT_CONTENT_FILL_IN_THE_BLANK) {
      return;
    }
    let payload = this.parsePayload(this.props.contentData.payload);
    if (payload == null) {
      return (<div/>)
    }
    return (
      <div>
        {this.photoAttachment(payload)}
        {Localization.strings.DESCRIPTION_FILL_IN_THE_BLANK_BEFORE + ": " + (payload.text1 != null? payload.text1 : "")}
        <br/>
        {Localization.strings.DESCRIPTION_FILL_IN_THE_BLANK_AFTER + ": " + (payload.text2 != null? payload.text2 : "")}
      </div>
    )
  }

  mindMapLink(link, boxDict) {
    let points = [];
    let point0 = boxDict[link[0]];
    let point1 = boxDict[link[1]];
    if (point0 != null) {
      points.push(point0.x + this.state.boxWidth / 2);
      points.push(point0.y + this.state.boxHeight / 2);
    }
    if (point1 != null) {
      points.push(point1.x + this.state.boxWidth / 2);
      points.push(point1.y + this.state.boxHeight / 2);
    }
    let id = points.toString();
    return (
      <Line
        key={"line "+ id}
        id={id}
        points={points}
        stroke={blueGrey[500]}
        strokeWidth={2}
      />
    )
  }

  mindMapBox(box) {
    let kind = (box.kind != null? box.kind : 0);
    let x = (box.x != null? box.x : 0);
    let y = (box.y != null? box.y : 0);
    let color = blue[500];
    return [
      <Rect
        key={box.id + " Rect A"}
        id={box.id}
        x={x}
        y={y}
        width={this.state.boxWidth}
        height={this.state.boxHeight}
        fill={color}
        cornerRadius={4}
        shadowBlur={4}
        shadowOffsetX={2}
        shadowOffsetY={2}
        shadowOpacity={0.4}
      />,
      <If condition={kind==0}>
        <Then>
          <Rect
            key={box.id + " Rect B"}
            x={x + this.state.boxPadding / 2.0}
            y={y + this.state.boxPadding / 2.0}
            fill={'White'}
            width={this.state.boxWidth - this.state.boxPadding}
            height={this.state.boxHeight - this.state.boxPadding}
            cornerRadius={2}
          />
        </Then>
      </If>,
      <Text
        key={box.id + " Text"}
        id={box.id}
        name='text'
        x={x + this.state.boxPadding / 2.0}
        y={y + this.state.boxPadding / 2.0}
        text={(kind == 0? box.label : Localization.strings.MIND_MAP_FILL_IN_BOX)}
        fill={kind == 0? 'Black' : 'White'}
        fontSize={12}
        align='center'
        verticalAlign='middle'
        wrap='word'
        width={this.state.boxWidth - this.state.boxPadding}
        height={this.state.boxHeight - this.state.boxPadding}
      />
    ]
  }

  _onReady(event) {
    // access to player in all event handlers via event.target
    event.target.pauseVideo();
  }
  
  movieclip(){
    const opts = {
      height: '150',
      width: '300',
      playerVars: {
        autoplay: 1,
      },
    };
    let kind = parseInt(this.props.contentData.kind);
    if (kind != Config.HOTSPOT_CONTENT_MOVIECLIP) {
      return;
    }
    let payload = this.parsePayload(this.props.contentData.payload);
    if (payload == null) {
      return (<div/>)
    }

    let URLText = payload.URLText;
    let VideoId = getYouTubeID(URLText);

    return(
      <YouTube videoId={VideoId} opts={opts} onReady = {this._onReady}></YouTube>
    )
    
  }

  fillInMindMap() {
    let kind = parseInt(this.props.contentData.kind);
    if (kind != Config.HOTSPOT_CONTENT_FILL_IN_MIND_MAP) {
      return;
    }
    let payload = this.parsePayload(this.props.contentData.payload);
    if (payload == null) {
      return (<div/>)
    }
    let linkList = (payload.linkList != null? payload.linkList : []);
    let boxList = (payload.boxList != null? payload.boxList : []);
    let boxDict = {};
    for (let i = 0; i < boxList.length; i++) {
      let key = boxList[i].id;
      if (boxDict[key] == null) {
        boxDict[key] = boxList[i];
      }
    }
    return (
      <div ref="stageDiv">
        <Stage width={this.state.stageWidth} height={this.state.stageHeight}>
          <Layer>
            <Rect
              x={0}
              y={0}
              width={this.state.stageWidth}
              height={this.state.stageHeight}
              fill={grey[200]}
              cornerRadius={4}
            />
          </Layer>
          <Layer>
            {
              linkList.map( (link, i) => {
                return (
                  this.mindMapLink(link, boxDict)
                )
              })
            }
          </Layer>
          <Layer>
            {
              boxList.map( (box, i) => {
                return (
                  this.mindMapBox(box)
                )
              })
            }
          </Layer>
        </Stage>
      </div>
    )
  }

  render() {
    let contentData = this.props.contentData;
    let content = [];
    if (contentData != null && contentData.content != null) {
      content = contentData.content.split(/(\r\n|\n|\r)/gm);
    }
    return (
      <div>
        <Typography>
          {contentData.name}
        </Typography>
        {
          content.map( (row, i) => {
            let urlStart = row.indexOf("http");
            if (urlStart > -1) {
              let urlEnd = row.indexOf(" ", urlStart);
              if (urlEnd < 0) {
                urlEnd = row.length;
              }
              let url = row.substring(urlStart, urlEnd);
              return (
                <Typography key={"content " + i}>
                  {row.substring(0, urlStart)}
                  <a href={url} target="_blank">{url}</a>
                  {row.substring(urlEnd)}
                </Typography>
              )
            }
            else {
              return (
                <Typography key={"content " + i}>
                  {row}
                </Typography>
              )
            }
          })
        }
        <Switch condition={parseInt(contentData.kind)}>
          <Case value={Config.HOTSPOT_CONTENT_SIMPLE_DESCRIPTION}>
            {this.simpleDescription()}
          </Case>
          <Case value={Config.HOTSPOT_CONTENT_MC_OF_TEXTS}>
            {this.mcText()}
          </Case>
          <Case value={Config.HOTSPOT_CONTENT_MC_OF_TEXTS_MULTI}>
            {this.mcText()}
          </Case>
          <Case value={Config.HOTSPOT_CONTENT_MC_OF_PICTURES}>
            {this.mcPic()}
          </Case>
          <Case value={Config.HOTSPOT_CONTENT_MC_OF_PICTURES_MULTI}>
            {this.mcPic()}
          </Case>
          <Case value={Config.HOTSPOT_CONTENT_VOICE_OVER}>
            {this.voiceOver()}
          </Case>
          <Case value={Config.HOTSPOT_CONTENT_TABLE_AND_CELL}>
            {this.tableAndCell()}
          </Case>
          <Case value={Config.HOTSPOT_CONTENT_FILL_IN_THE_BLANK}>
            {this.fillInTheBlank()}
          </Case>
          <Case value={Config.HOTSPOT_CONTENT_FILL_IN_MIND_MAP}>
            {this.fillInMindMap()}
          </Case>
          <Case value={Config.HOTSPOT_CONTENT_MOVIECLIP}>
            {this.movieclip()}
          </Case>
        </Switch>
      </div>
    )
  }
}

export default LocaleOverviewHotspotContent;
